export default {
  "": "",
  "24hChange": "24小時漲跌幅",
  "24hTurnover": "24小時交易額",
  "action": "操作",
  "AddLoan": "增加",
  "AdjustLoanFail": "質押資產調整失敗，請重試。",
  "all": "全部",
  "apply": "申請",
  "assets": "資產",
  "available": "剩餘",
  "balance": "可用餘額",
  "bi_all": "全部",
  "bi_average_change": "24 小時平均漲跌幅",
  "bi_down_amount": "下跌幣種交易量",
  "bi_down_num": "下跌幣種",
  "bi_eth_gas": "ETH 礦工費",
  "bi_google_tips": "數值取自 Google 趨勢，代表指定時間內搜索熱度的最高值，熱度最高的字詞得 100 分。",
  "bi_google_trends": "Google 趨勢上的 BTC 熱度",
  "bi_market_cap": "全球加密貨幣市值 (USDT)",
  "bi_market_distribution": "市值分佈",
  "bi_market_sentiment": "市場情緒",
  "bi_market_trends": "加密貨幣市場行情",
  "bi_market_volatility": "加密貨幣市場波動性",
  "bi_normal_amount": "持平幣種交易量",
  "bi_normal_num": "持平幣種",
  "bi_page_title": "實時跟踪加密貨幣市場行情、情緒和波動性 {'|'} Bybit",
  "bi_price_distribution": "漲跌分佈",
  "bi_ranking": "排名",
  "bi_ranking_sector": "按板塊排名",
  "bi_ranking_tips": "目前僅显示該板塊內市值前 3 的幣種。",
  "bi_sentiment1": "極度恐懼",
  "bi_sentiment2": "恐懼",
  "bi_sentiment3": "中立",
  "bi_sentiment4": "貪婪",
  "bi_sentiment5": "極度貪婪",
  "bi_social": "社交媒體熱度",
  "bi_td_trade": "交易",
  "bi_th_action": "操作",
  "bi_th_change": "24 小時漲跌幅",
  "bi_th_currency": "幣種",
  "bi_th_market": "市值",
  "bi_th_price": "價格",
  "bi_th_sector": "版塊",
  "bi_th_up_down": "上漲/下跌",
  "bi_th_volume": "24 小時交易量",
  "bi_top_20": "按市值排名",
  "bi_top_gain": "領漲幣種（漲幅）",
  "bi_total_market": "總市值",
  "bi_trading_distribution": "交易量分佈",
  "bi_trading_vol": "全球加密貨幣 24 小時交易量 (USDT)",
  "bi_twitter_explore": "Twitter 探索",
  "bi_twitter_tips1": "Twitter 上近期新出現的加密貨幣關鍵詞",
  "bi_twitter_tips2": "Twitter 上近期熱度較高的加密貨幣關鍵詞",
  "bi_twitter_topics": "Twitter 熱門話題",
  "bi_up_amount": "上漲幣種交易量",
  "bi_up_num": "上漲幣種",
  "bi_view": "查看",
  "bi_volume_distribution": "交易量變化分佈",
  "botValidateErrCode101": "最小價格太低",
  "botValidateErrCode102": "最小價格太高",
  "botValidateErrCode103": "最大價格太低",
  "botValidateErrCode104": "最大價格太高",
  "botValidateErrCode105": "網格數太少",
  "botValidateErrCode106": "網格數太多",
  "botValidateErrCode107": "投資額太低，未滿足投資要求。",
  "botValidateErrCode108": "投資額太高，大於合約投資上限。",
  "botValidateErrCode109": "止盈價太低",
  "botValidateErrCode110": "止盈價太高",
  "botValidateErrCode111": "止損價太低",
  "botValidateErrCode112": "止損價太高",
  "botValidateErrCode113": "入場價太低",
  "botValidateErrCode114": "入場價太高",
  "cancel": "取消",
  "cancelAll": "撤銷全部",
  "cancelOrder": "撤單",
  "chart": "圖表",
  "close": "關閉",
  "confirm": "確認",
  "contest-about-to-start": "即將開始",
  "contest-accumulate-volume": "累計交易量",
  "contest-accumulate-volume-start": "報名成功！您的現貨交易量將納入計算。",
  "contest-achieve-standards": "合格",
  "contest-activity-rules": "活動規則",
  "contest-activity-rules-title": "活動規則",
  "contest-activity-time": "活動時間",
  "contest-countdown": "直至大賽結束",
  "contest-countdown-day": "天",
  "contest-cumulative-volume": "交易總量（{unit}）",
  "contest-current-volume": "當前交易量",
  "contest-date-range": "{month}  {date} 日 {time} {utc} ",
  "contest-dialog-btn-text": "確認",
  "contest-difference-to-foward": "距離前一排名只差 {num} {unit}",
  "contest-earn-rewards": "獎勵（{unit}）",
  "contest-ended": "活動已結束",
  "contest-find-more-premium-assets": "在現貨平台繼續交易！",
  "contest-latest-update": "數據將於 {time}{utc} 更新。",
  "contest-less": "隱藏",
  "contest-limit-desc": "您需要達到最低現貨交易量 {amount} {unit}，方可領取獎勵。",
  "contest-list-show-more": "展示更多",
  "contest-login": "登入",
  "contest-month": "1 月,2 月,3 月,4 月,5 月,6 月,7 月,8 月,9 月,10 月,11 月,12 月",
  "contest-my-rank": "我的排名",
  "contest-no-rank": "暫無排名。敬請關注！",
  "contest-no-rank-yet": "暫無排名",
  "contest-not-registered": "您沒有報名參加本次交易大賽",
  "contest-num-of-participants": "參與人數",
  "contest-popup-success": "立即交易",
  "contest-ranking": "排名",
  "contest-register": "立刻報名",
  "contest-registered": "已報名",
  "contest-registration-ends": "報名結束",
  "contest-rewards-earned": "獎勵（{unit}）",
  "contest-share": "分享",
  "contest-symbol-scope": "現貨交易對",
  "contest-terms-conditions": "<p>條款和條件</p>",
  "contest-to-spot-trade": "活動已開始。立即充值和交易！",
  "contest-u-earned-king": "您已獲得「超級交易者」獎勵",
  "contest-u-earned-sunny": "您已獲得「頂級交易者」獎勵",
  "contest-unqualified": "很遺憾，您沒有參與資格。如有任何疑問，請聯絡我們的客服團隊。",
  "contest-updated-daily-at": "* 最近更新時間為 {time}（UTC0）。",
  "contest-will-start-tips": "報名成功！活動將於 {time} 開始。敬請關注！",
  "contest-your-rewards": "您符合領獎資格",
  "contract_account": "合約賬戶",
  "createErrorCode400": "用戶發送的數據包含非法參數。有關更多信息，請查看錯誤消息和錯誤詳情。",
  "createErrorCode401": "餘額不足。",
  "createErrorCode402": "用戶創建的機器人數量已達上限。",
  "createErrorCode403": "服務禁用",
  "createErrorCode404": "所請求資源未找到。",
  "createErrorCode407": "該用戶類型不支持創建機器人子賬戶。",
  "createErrorCode408": "選擇了重複定投標的",
  "createErrorCode409": "最大投資額無效",
  "createErrorCode410": "最大投資額無效",
  "createErrorCode411": "機器人已被關閉",
  "createErrorCode412": "統一保證金賬戶升級中",
  "createErrorCode500": "服務器內部錯誤",
  "createErrorCode501": "內部處理超時",
  "createErrorCode503": "當前定投機器人無法關閉，可能正在進行定投買入。",
  "currency": "幣種",
  "dailyRate": "日利率",
  "deposit": "充值",
  "detail": "詳情",
  "direction": "方向",
  "end": "結束時間",
  "fiat": "法幣",
  "filled": "已成交",
  "filter": "篩選",
  "from": "開始時間",
  "global_setting_quick_order_desc": "<p>1. 市價單（快捷下單）</p>\n<p>2. 請注意，填寫的購買數量可能與輸入的訂單數量略有不同。 </p>",
  "global_setting_quick_order_label": "快捷下單",
  "global_setting_title": "自定義設置（適用於現貨）",
  "hint": "提示",
  "innovateQuota": "可用額度",
  "kline": "K線",
  "l_version_tip": "目前版本不支援Launchpad活動，請更新至最新版！",
  "LastTradedPrice": "最新價",
  "leverage": "槓桿倍數",
  "leverage_can_borrow": "支援借幣",
  "leverage_can_deposit": "支援保證金",
  "leverage_data": "槓桿數據",
  "leverage_forced_order": "強平順序",
  "leverage_go_trade": "立即交易",
  "leverage_loan_limit": "借貸限額",
  "leverage_min_borrow": "借貸下限",
  "leverage_off_trade_tip": "請開啟槓桿，然後參與槓桿交易。",
  "leverage_yearly_rate": "年利率",
  "leverageCloseErrInfo": "操作失敗！您需要還清全部欠款後，才能關閉槓桿交易。",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "操作失敗！您的統一保證金賬戶的 IM 或 MM 佔用率已超過預警值。",
  "leverageLP_banner_title": "Bybit 現貨槓桿交易",
  "leverageLP-banner-desc": "借幣交易，賺取更高收益。",
  "leverageLP-faq-a1": "完整列表請參見<a href=\"{url}\" target=\"_blank\" >槓桿交易的抵押資產與可借貸資產清單</a>。",
  "leverageLP-faq-a10": "請點擊「訂單 → 現貨訂單 → 還款歷史 → 強平」，查看強平記錄。",
  "leverageLP-faq-a11": "請點擊「訂單 → 現貨訂單 → 還款歷史」，查看您的借貸與還款記錄。",
  "leverageLP-faq-a2": "Bybit 槓桿交易會產生現貨交易手續費、利息與強平費。欲瞭解詳情，敬請閱讀<a href=\"{url}\" target=\"_blank\" >Bybit 現貨槓桿交易：手續費概覽與明細</a>。",
  "leverageLP-faq-a3": "槓桿交易直接透過 Bybit 現貨賬戶進行。",
  "leverageLP-faq-a4": "不可以。開通機構借貸的用戶無法參與槓桿交易。如需將您的 UID 從機構借貸用戶名單中移除，請發送郵件至 institutional_services{'@'}bybit.com。",
  "leverageLP-faq-a5": "不同 VIP 等級的借貸利率不同。詳情請參見<a href=\"{url}\" target=\"_blank\" >槓桿交易數據</a>。",
  "leverageLP-faq-a6": "利息按小時計算。請注意，不足 1 小時也將按 1 小時計算。",
  "leverageLP-faq-a7": "您將透過短信與郵件收到 2 次風險通知：\n\n(1) 現貨賬戶的風險等級 ≥ 87% - 觸發風險警報，系統發送短信與郵件通知，提醒您追加抵押品（轉入更多抵押資產）以防強平。\n\n(2) 現貨賬戶的風險等級 ≥ 95%，您將收到短信與郵件形式的強平警報，通知倉位已被強平。\n\n有關強平流程與指標的詳情，敬請參見<a href=\"{url}\" target=\"_blank\" >現貨槓桿交易的風險與強制平倉</a>。",
  "leverageLP-faq-a8": "槓桿交易保險基金 (MAF) 用於抵消用戶在強平後因賬戶資金不足以償還貸款所造成的穿倉損失。\n\n如果現貨賬戶資不抵債，平台將使用這項基金來償還債務。因此，用戶需要繳納強平費，補充槓桿交易保險基金。",
  "leverageLP-faq-a9": "所有保證金用於償還貸款後，倘若還有欠款，則由槓桿交易保險基金承擔損失。",
  "leverageLP-faq-q1": "哪些幣種可作為槓桿交易的抵押品或可借貸資產？",
  "leverageLP-faq-q10": "在哪裡查看強平記錄？",
  "leverageLP-faq-q11": "在哪裡查看借貸與還款記錄？",
  "leverageLP-faq-q2": "Bybit 槓桿交易是否收取手續費？",
  "leverageLP-faq-q3": "參與槓桿交易時，應該使用哪個賬戶？",
  "leverageLP-faq-q4": "開通機構借貸後，能否參與槓桿交易？",
  "leverageLP-faq-q5": "Bybit 槓桿交易的借貸利率是多少？",
  "leverageLP-faq-q6": "多長時間開始計息？",
  "leverageLP-faq-q7": "在什麼情況下，我會收到槓桿交易的風險通知？",
  "leverageLP-faq-q8": "什麼是槓桿交易保險基金？",
  "leverageLP-faq-q9": "遭到強平後，如果現貨賬戶資不抵債會如何？",
  "leverageLP-faq-title": "常見問題解答",
  "leverageLP-feature-title": "槓桿交易有哪些優勢？",
  "leverageLP-feature1": "交易收益倍增",
  "leverageLP-feature2": "支援做多/做空交易",
  "leverageLP-feature3": "提高資金利用率",
  "leverageLP-feature4": "資產多元化",
  "leverageLP-whats-leverage": "什麼是現貨槓桿交易？",
  "leverageLP-whats-leverage-c": "Bybit 的現貨槓桿交易是現貨交易的衍生產品。您可以抵押現貨賬戶中的資產，從 Bybit 借貸資金，然後在現貨市場中透過槓桿放大潛在收益。",
  "leverageTest": "槓桿交易測試",
  "leverageTestSubTitle": "答對全部題目才可以開始槓桿交易。",
  "leverageTryAgain": "系統異常，請您稍後重試！",
  "liquidate": "已強制平倉",
  "liquidationErrorInfo": "操作失敗！賬戶已觸發強制平倉。",
  "load_more": "加載更多",
  "loan": "借款",
  "loan_limit": "借款期限",
  "loan_spot_account": "現貨賬戶",
  "loanLualityDeposit1": "只有當前質押率小於初始質押率時，方可減少質押資產。",
  "loanLualityDeposit2": "可減少的質押數量上限是達到初始質押率的數量。",
  "loanLualityDeposit3": "若當前質押率大於等於初始質押率，則不允許減少質押資產。",
  "loanTime": "借款時間",
  "login": "登錄",
  "lp_go_home": "返回",
  "lpn_one_progress_info": "結果預期公佈於",
  "lpn_order_btn": "我的認購",
  "lpn_order_btn_cancel": "取消",
  "lpn_order_btn_confirm": "確認",
  "lpn_order_submit_error": "失敗！",
  "lpn_order_submit_error_desc": "系統錯誤。請稍後再試。",
  "lpn_unfold": "更多資訊",
  "lt_all": "全部",
  "lt_amount": "金額",
  "lt_amount_not_enough": "您的 {currency} 可用餘額不足！",
  "lt_entry_tips": "{symbol} 支持槓桿代幣{direction}交易，立即交易！",
  "lt_freerate": "費率",
  "lt_lowcase_redemption": "贖回",
  "lt_lowcase_subscription": "申購",
  "lt_open_success_txt": "恭喜，您已成功啟用槓桿代幣！",
  "lt_orders_submitted": "{ordertype} {quantity} 的訂單已成功提交。",
  "lt_redemption": "贖回",
  "lt_redemption_failed_change_position": "當前交易對正在調倉，無法贖回，請稍後再試。",
  "lt_redemption_failed_closed": "該資產當前已關閉贖回，請稍後再試。",
  "lt_redemption_failed_input_quantity": "請輸入贖回數量",
  "lt_redemption_failed_net_worth": "當前資產淨值錯誤，無法贖回，請稍後再試。",
  "lt_redemption_failed_wear_position": "您的賬戶正在強平中，無法贖回，請稍後再試。",
  "lt_redemption_max_quanlity": "該資產的單筆最大贖回金額不得大於 {quantity}。",
  "lt_redemption_min_quanlity": "該資產的單筆最小贖回金額不得小於 {quantity}。",
  "lt_redemption_tips": "實際贖回金額以最終成交結果為準。",
  "lt_subscription": "申購",
  "lt_subscription_failed_change_position": "當前交易對正在調倉，無法申購，請稍後再試。",
  "lt_subscription_failed_close_position": "您的賬戶正在強平中，無法申購，請稍後再試。",
  "lt_subscription_failed_closed": "該資產當前已關閉申購，請稍後再試。",
  "lt_subscription_failed_input_amount": "請輸入申購數量",
  "lt_subscription_failed_invalid_value": "當前資產淨值錯誤，無法申購，請稍後再試。",
  "lt_subscription_failed_large_amount": "申購金額過高會導致全倉風險率升高，面臨強平風險。",
  "lt_subscription_failed_wear_position": "您的賬戶已穿倉，無法申購，請稍後再試。",
  "lt_subscription_max_amount": "該資產的單筆最大申購金額不得大於 {amount}。",
  "lt_subscription_min_amount": "該資產的單筆最小申購金額不得小於 {amount}。",
  "lt_subscription_redemption": "申購和贖回",
  "lt_subscription_redemption_records": "申購和贖回記錄",
  "lt_subscription_tips": "實際申購金額以最終成交結果為準。",
  "lt_subscription_usdt_not_enough": "您的 USDT 可用餘額不足！請先儲值或轉入。",
  "lt-landing-banner-desc": "自帶槓桿，無強平風險",
  "lt-landing-banner-title": "Bybit 槓桿代幣",
  "lt-landing-faq-a1": "NAV（全稱「資產淨值」）是指槓桿代幣的價值。槓桿代幣的 NAV 隨永續合約市場的價格波動而變化。",
  "lt-landing-faq-a2": "以 BTC 為例：\n\nBTC3L 指 3 倍看多 BTC。\n\nBTC3S 指 3 倍看空 BTC。",
  "lt-landing-faq-a3": "槓桿代幣交易直接通過 Bybit 現貨賬戶進行。",
  "lt-landing-faq-a4": "敬請參見<a href=\"{url}\" target=\"_blank\" >槓桿代幣與衍生品交易的區別</a>。",
  "lt-landing-faq-a5": "敬請參見 <a href=\"{url}\" target=\"_blank\" >Bybit 槓桿代幣：手續費概覽</a>。",
  "lt-landing-faq-a6": "沒有強平風險。\n\n以 BTC3L 為例，調倉觸發閾值為 [2,4]。當實際槓桿率 ≥ 4 倍或 ≤ 2 倍時，觸發調倉機制，重新調整為 3 倍的目標槓桿。\n\n注：槓桿代幣的資產淨值可能歸零，歸零後無法恢復。",
  "lt-landing-faq-a7": "調倉機制是指根據目標槓桿，靈活調整標的資產的永續合約倉位。實際槓桿倍數在超出一定區間後將自動觸發調倉。\n\n欲了解詳情，敬請參見 <a href=\"{url}\" target=\"_blank\">Bybit 槓桿代幣調倉機制</a>。",
  "lt-landing-faq-a8": "平台暫不支持提幣。",
  "lt-landing-faq-q1": "什麼是資產淨值 (NAV)？",
  "lt-landing-faq-q2": "槓桿代幣的名稱代表什麼？",
  "lt-landing-faq-q3": "Bybit 的槓桿代幣交易使用哪種賬戶？",
  "lt-landing-faq-q4": "Bybit 的槓桿代幣與衍生品交易有何不同？",
  "lt-landing-faq-q5": "槓桿代幣涉及哪些手續費？",
  "lt-landing-faq-q6": "我的槓桿代幣倉位是否會被強平？",
  "lt-landing-faq-q7": "什麼是調倉機制？",
  "lt-landing-faq-q8": "槓桿代幣是否支持提幣？",
  "lt-landing-faq-title": "常見問題解答",
  "lt-landing-feature-title": "槓桿代幣的優勢",
  "lt-landing-feature1": "自帶槓桿，放大收益",
  "lt-landing-feature2": "無強平風險",
  "lt-landing-feature3": "高效利用資金",
  "lt-landing-feature4": "交易方便快捷",
  "lt-landing-learn-more": "了解詳情",
  "lt-landing-operation": "操作",
  "lt-landing-symbol": "交易對",
  "lt-landing-whats-lt": "什麼是槓桿代幣？",
  "lt-landing-whats-lt-c": "槓桿代幣是一種新型金融衍生品，用戶無需繳納保證金即可通過自帶槓桿屬性獲得高額收益，無強制平倉風險。\n\n每種槓桿代幣代表一系列永續合約倉位。\n\n槓桿代幣的資產淨值 (NAV) 隨永續合約市場的價格波動而變化。",
  "lt-learning-video-title": "槓桿代幣新手教學視頻",
  "ltLearningVideo": "視頻教程",
  "ltNav": "資產淨值",
  "ltOpenRiskContent": "您可透過槓桿代幣對基礎資產的槓桿版本進行投資。Bybit 保留根據市場情況自行調整服務條款、採取以下任意行動且無需事先通知的權利：\n1.根據市場情況移除相關交易對。\n2.施加產品限制，例如持倉限額，具體持倉限額數值會根據市場情況做出相應調整，請關注官方公告。由於技術原因等可能會對持倉限額的計算造成一定差異，請熟知相關風險。\n3.根據市場情況相應調整倉位。\n4.終止與槓桿代幣相關的服務條款。\n您有責任隨時瞭解我們關於該產品的公告。在繼續之前，您應該閱讀並理解我們的風險披露和產品機制。 Bybit 不承擔與槓桿代幣相關的任何損失和風險。選擇繼續，您被視為已閱讀、理解並同意我們的<a href={url} target=\"_blank\">服務條款</a>。",
  "ltOpenRiskSubmit": "我同意簽署本協議並開通槓桿代幣服務",
  "ltOpenRiskTitle": "槓桿代幣服務協議",
  "ltTestDialogContent": "您確定要退出測試嗎？中途退出測試，答案將不做保存",
  "ltTestDialogContinue": "繼續答題",
  "ltTestDialogExit": "確定退出",
  "ltTestDialogTitle": "確認",
  "ltTestDone": "您已完成<span>{num}/{numAll}</span> 道題目",
  "ltTestDoneFail": "您共答對 {num}/{numAll} 道題目，測試未通過，請重新作答",
  "ltTestPassContent": "恭喜，您已通過測驗！",
  "ltTestPassRead": "瞭解更多",
  "ltTestPassReject": "略過",
  "ltTestResubmit": "重新作答",
  "ltTestSubmit": "提交答案",
  "ltTestSubTitle": "答對全部題目才可以開始槓槓代幣產品交易",
  "ltTestTitle": "風險測試",
  "ltUnderlying": "標的",
  "margin_coin": "幣種",
  "margin_discount": "折算率",
  "margin_discount_eg": "舉例：",
  "margin_discount_eg_body": "假設賬戶內有 BTC 和 XRP 作為槓桿保證金，用戶賬戶內有 1 BTC、50 XRP，假設此時 BTCUSDT 的市場價格為 50,000。因為 50 XRP 的幣種折算率為 0；1 BTC 的價值處於 0~5,000,000 USDT 之間，BTC 的幣種折算率為 1，則賬戶的 USDT 價值為 50,000 * 1 * 1 = 50,000 USDT。",
  "margin_discount_rate": "幣種折算率",
  "margin_lq_order": "強平順序",
  "MARKET": "市場價格",
  "max": "最大",
  "more": "更多",
  "network_error": "請求失敗，請稍後重試。",
  "NEW": "待成交",
  "nextPage": "下一頁",
  "nodata": "暫無記錄",
  "none": "無",
  "noRecordFound": "暫無記錄",
  "og_description": "加入 Bybit 現貨交易平台，安心買賣和交易 {symbol}。坐享低手續費和高流動性，開啟全新交易體驗。",
  "og_title": "{symbol} {'|'} 買賣交易，盡享低手續費 {'|'} Bybit 現貨",
  "ol_agree": "我已閱讀並同意",
  "ol_agrmt": "數字資產借貸協議",
  "ol_agrmt_2": "《數字資產借貸協議》",
  "ol_agrmt_err": "必須簽署《數字資產借貸協議》",
  "ol_amt": "借貸金額",
  "ol_amt_err": "{condition} 借貸金額為 {amount} {unit}",
  "ol_amt_tip": "請輸入借貸金額",
  "ol_app_sub": "借貸申請已提交",
  "ol_app_time": "申請時間",
  "ol_apply_title": "機構借貸線上申請",
  "ol_cancel": "您是否放棄本次申請？",
  "ol_cfm_product": "機構借貸產品",
  "ol_check_app": "查詢申請",
  "ol_coin": "幣種",
  "ol_col_amt": "金額",
  "ol_col_app_tm": "申請時間",
  "ol_col_dl": "借貸期限",
  "ol_col_no": "訂單號",
  "ol_col_pn": "產品名稱",
  "ol_col_sub": "子賬戶",
  "ol_confirm": "借貸申請確認",
  "ol_contact_desc": "請務必填寫正確的聯繫方式，郵箱和手機號將會接收風控警報。",
  "ol_contact_tip": "請聯繫商務團隊",
  "ol_contact_title": "聯繫方式",
  "ol_detail_title": "借貸申請詳情",
  "ol_eg": "示例",
  "ol_email": "郵箱",
  "ol_email_err_invalid": "郵箱地址無效",
  "ol_email_tip": "請填寫您的郵箱地址",
  "ol_max": "maximum",
  "ol_mgr": "專屬客戶經理 ID",
  "ol_mgr_err_invalid": "客戶經理 ID 無效",
  "ol_mgr_link": "點擊獲取專屬客戶經理 ID",
  "ol_mgr_tip": "請輸入專屬客戶經理的 ID",
  "ol_min": "minimum",
  "ol_mine_title": "我的借貸申請",
  "ol_month": "{month} 個月",
  "ol_no_code_rcd": "未搜索到相關國家編號",
  "ol_notice_desc": "<li>機構借貸業務僅向機構交易者開放</li>\n<li>申請借貸的機構交易者，所持資產不得小於 50 萬 USDT</li>\n<li>根據用戶所選產品，借貸資金可應用於現貨市場或合約市場</li>",
  "ol_notice_desc_lmt": "<li>最小申請借貸金額為 100 萬 USDT，最大申請借貸金額為 2000 萬 USDT。 </li>",
  "ol_notice_title": "機構借貸須知",
  "ol_phone": "手機號",
  "ol_phone_err": "請選擇區號並填寫手機號",
  "ol_phone_err_invalid": "手機號碼格式無效",
  "ol_phone_tip": "請輸入您的手機號",
  "ol_prd": "請選擇機構借貸產品",
  "ol_prd_3x_spot": "機構借貸：3 倍槓桿（現貨）",
  "ol_prd_3x_spot_futures": "機構借貸：3 倍槓桿（現貨和衍生品）",
  "ol_prd_5x_spot": "機構借貸：5 倍槓桿（現貨）",
  "ol_prd_link": "了解產品詳情",
  "ol_prd_tip": "如果現貨賬戶資產兌換成非保證金資產，則面臨強平風險。敬請點擊<a href={url} target=\"_blank\">此處</a>，詳細瞭解 Bybit 現貨市場支持的保證金資產。",
  "ol_recent_year_only": "僅支持查詢近 1 年的借貸申請",
  "ol_status": "申請狀態",
  "ol_status_list": "全部, 已受理,申請確認, 申請拒絕, 已放款",
  "ol_subacc": "關聯子賬戶",
  "ol_subacc_tip": "請輸入待關聯子賬戶的 UID。如果數量很多，請聯繫商務團隊。",
  "ol_term": "借貸期限",
  "ol_term_err": "請選擇申請借貸的期限。",
  "ol_unit_month": "單位：月",
  "ol_view_agrmt": "查看協議附件",
  "operationSuccess": "成功",
  "or": "或",
  "orderBook": "訂單表",
  "orderHistory": "訂單歷史",
  "orderId": "訂單單號",
  "orderSuccessful": "訂單提交成功",
  "orderType": "訂單類型",
  "otcErrorInfo": "抱歉，您開通了機構借貸，無法進行槓桿交易。",
  "outstanding": "待還",
  "pa_accumated_profit_descript": "累計收益額是指在一定時間段內的每日收益額之和；累計收益額圖表僅顯示截至前一天的數據。",
  "pa_accumated_profit_select": "當前累計收益額",
  "pa_accumated_profit_title": "累計收益額",
  "pa_accumulated_account": "現貨賬戶累計收益率",
  "pa_accumulated_btc": "BTC 價格累計漲跌率",
  "pa_accumulated_btc_select": "當前 BTC 價格累計漲跌率",
  "pa_accumulated_pnl": "7 日盈虧",
  "pa_accumulated_pnl_select": "當前累計收益率",
  "pa_accumulated_roi_descript": "累計收益率是指在一定時間段內的整體盈利效率；累計收益率圖表僅顯示截至前一天的數據。",
  "pa_accumulated_roi_title": "累計收益率",
  "pa_assets_distribution_descript": "資產分佈是指現貨賬戶中各個幣種折算成 USDT 后，所得估值在總資產估值中的佔比。",
  "pa_assets_distribution_title": "資產分佈",
  "pa_daily_pnl": "今日盈虧",
  "pa_daily_profit_descript": "每日盈虧圖表僅顯示截至前一天的數據。",
  "pa_daily_profit_select": "當日盈虧",
  "pa_daily_profit_title": "每日盈虧",
  "pa_last_30_day": "最近 30 天",
  "pa_last_7_day": "最近 7 天",
  "pa_last_90_day": "最近 90 天",
  "pa_others": "其他",
  "pa_page_description": "實時掌握資產狀況，及時調整投資策略，強佔投資先機！",
  "pa_page_title": "現貨資產盈虧分析",
  "pa_quantity": "{Coin} 數量",
  "pa_spot_pnl_descript": "1. 現貨盈虧分析數據每天 0:00 (UTC) 起開始更新。\n2. 最新現貨盈虧分析數據更新計算時間為每天 0:00-6:00 (UTC)，更新后的數據將於 6:00 (UTC) 后显示。",
  "pa_spot_pnl_title": "現貨盈虧分析",
  "pa_total_assets": "總資產",
  "pa_total_assets_value_descript": "總資產估值是指現貨賬戶中所有資產的估值總和（含借入資產），儲值、提幣、轉入轉出、借貸以及槓桿交易等行為均會影響總資產估值。",
  "pa_total_assets_value_select": "資產估值",
  "pa_total_assets_value_title": "總資產估值",
  "pa_update_on": "最近更新時間：",
  "pa_value": "{Coin} 估值",
  "pa_weightage": "{Coin} 佔比",
  "pauseTradeTip": "{symbol} 目前暫時無法交易。敬請參閱我們的 <a href=\"{url}\" target=\"_blank\">部落格 </a>，瞭解詳情。",
  "placeHolder": "請選擇",
  "prevPage": "上一頁",
  "price": "價格",
  "quantity": "數量",
  "ReduceLoan": "減少",
  "ReduceLoanAssets": "減少質押資產",
  "ReduceLoanTip1": "不能減少質押資產，只有當前質押率小於初始質押率時才能減少質押資產。",
  "ReduceLoanTip2": "不能減少質押資產，減少的數量需小於質押資產可減數量。",
  "ReduceLoanTip3": "不能減少質押資產，減少的數量需小於質押資產可減數量，請重試。",
  "ReduceLoanTip4": "您可以在訂單頁面調整質押金，您可以隨時添加更多質押金，若當前質押率小於初始質押率時，還可以減少質押資產。",
  "repayment": "還款",
  "reset": "重設",
  "reverse_contract_account": "反向合約賬戶",
  "riskWarning": "確認彈窗",
  "search": "搜尋",
  "side": "方向",
  "signup": "註冊",
  "spot_account": "現貨賬戶",
  "status": "狀態",
  "stop_limit": "止盈止損",
  "stop_limit_tips_2": "當前有止盈止損委託單，暫不支持開啟槓桿交易。",
  "success": "成功",
  "sure": "sure",
  "tests1": "",
  "times": "次",
  "timestamp": "時間",
  "title_404": "404 {'|'} Bybit 貨交易  ",
  "to": "至",
  "toastTheSymbolNotExist": "抱歉！您選擇的交易對暫無法訪問",
  "total": "累計",
  "tradeChange": "漲跌幅",
  "tradeId": "成交編號",
  "transfer": "劃轉",
  "usdc_contract_account": "USDC 合約賬戶",
  "VIP99": "至尊 VIP",
  "volume": "已成交量",
  "vote_btn_trade": "交易"
}